import 'simplebar/dist/simplebar.min.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

import { createRoot } from 'react-dom/client';

import { HelmetProvider } from 'react-helmet-async';

import { SettingsProvider } from 'contexts/SettingsContext';
import { CollapseDrawerProvider } from 'contexts/CollapseDrawerContext';
import App from 'App';
import history from './routers/history';
import CustomRouter from './routers/CustomRouter';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <SettingsProvider>
      <CollapseDrawerProvider>
        <CustomRouter history={history}>
          <App />
        </CustomRouter>
      </CollapseDrawerProvider>
    </SettingsProvider>
  </HelmetProvider>
);
